import React from 'react';

import { Calculator } from '../types';

import './ExchangeRateOneToOneInfo.scss';

interface ExchangeRateOneToOneInfoProps {
    calculator: Calculator;
}

const ExchangeRateOneToOneInfo = ({ calculator }: ExchangeRateOneToOneInfoProps) => {
    if (typeof calculator.to.amount === 'undefined' || typeof calculator.exchangeRate.from === 'undefined') {
        return null;
    }

    const exchangeResultShortened = calculator.exchangeRate.from.rate.toFixed(4);

    return (
        <div className="exchange-rate">
            <p>{`1 ${calculator.from.currency.currencyCode} ≈ ${exchangeResultShortened} ${calculator.to.currency.currencyCode}`}</p>
        </div>
    );
};

export default ExchangeRateOneToOneInfo;
